module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('article-detail-component', [(!_vm.$store.state.isEnhanced) ? _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.article.authors
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('sidebar-article-section', {
    attrs: {
      "slot": "bar",
      "article": _vm.article
    },
    slot: "bar"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "authors"
    },
    slot: "authors"
  }, [_c('issue-authors', {
    attrs: {
      "authors": _vm.article.authors
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "current-issue",
    attrs: {
      "slot": "current_article"
    },
    slot: "current_article"
  }, [_c('em', [_vm._v("Current Article:")]), _vm._v(" "), _c('condensed-issue', {
    staticClass: "mt-2",
    attrs: {
      "issue": _vm.article
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row correspondence-to"
  }, [_c('em', [_vm._v("Correspondence to: ")]), _vm._v(" "), _vm._l((_vm.correspondenceTo), function(contact) {
    return _c('span', {
      key: contact.email
    }, [_vm._v("\n      " + _vm._s(contact.firstName) + " " + _vm._s(contact.lastName) + ": "), _c('a', {
      attrs: {
        "href": ("mailto:" + (contact.email))
      }
    }, [_vm._v(_vm._s(contact.email))])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.detailsMode),
      expression: "!detailsMode"
    }],
    staticClass: "row"
  }, _vm._l((_vm.authors), function(author) {
    return _c('author', {
      key: author.id,
      staticClass: "col-xs-12",
      class: {
        'col-md-6': !_vm.$store.state.isEnhanced
      },
      attrs: {
        "author": author
      }
    }, [_c('span', {
      staticClass: "link",
      attrs: {
        "slot": "details-link"
      },
      on: {
        "click": function($event) {
          _vm.openDetails(author.id)
        }
      },
      slot: "details-link"
    }, [_vm._v("Read More >")])])
  })), _vm._v(" "), (_vm.detailsMode) ? _c('author-details', {
    attrs: {
      "author-id": _vm.authorDetailId
    }
  }, [_c('div', {
    staticClass: "row no-gutters justify-content-between",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "link",
    on: {
      "click": _vm.closeDetails
    }
  }, [_vm._v("< Back to all authors")]), _vm._v(" "), _c('b-button', {
    staticClass: "link",
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.closeDetails
    }
  }, [_c('icon', {
    attrs: {
      "name": "times"
    }
  })], 1)], 1)]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc1fa724"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/AuthorsPage.vue
// module id = 1479
// module chunks = 1